module.exports = require("swa-bootstrap-corporate-landing-home-page/car/car-types-data");